import { IntervalEnum } from '@modules/filters/enums';

export const intervalLabel = {
  [IntervalEnum.TenMinutes]: '10 min',
  [IntervalEnum.Hour]: 'Hour',
  [IntervalEnum.Day]: 'Day',
  [IntervalEnum.Week]: 'Week',
  [IntervalEnum.Month]: 'Month',
};
